import React from 'react';
import {render} from 'react-dom';
const AboutSection = () => (
  <section className="column section-about">
    <h2 className="text-center">About Us</h2>
    <span className="section_about__text">
      The year of inception – 1997. Founding Partners CA Dharmendra Chachan & CA Naresh Lath (in
      association for the last 33 years). Developed fiduciary relationship with sound corporates and
      businesses. Established core competencies and knowledge base. Well equipped and furnished
      office premises in Delhi . State of the art IT infrastructure. Empanelled with RBI &
      CAG. Founding partners are qualified Information System Auditors.
    </span>
    <div>
      <a href="/about" className="section_about__button">KNOW MORE</a>
    </div>
  </section>
);
export default AboutSection;



// WEBPACK FOOTER //
// ./src/HomePage/AboutSection.js